var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.57 1.7L2.57 0.33",
    stroke: "#8C8E90",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.42 1.7L9.42 0.33",
    stroke: "#8C8E90",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.96 1.01C0.78 1.01 -0.17 1.97 -0.17 3.15L-0.17 10.53C-0.17 11.71 0.78 12.67 1.96 12.67L10.04 12.67C11.21 12.67 12.17 11.71 12.17 10.53L12.17 3.15C12.16 1.97 11.21 1.01 10.03 1.01L1.96 1.01Z",
    stroke: "#8C8E90",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M-0.17 3.76L12.16 3.76",
    stroke: "#8C8E90",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.66 5.83C10.66 6.2 10.36 6.5 10 6.5C9.63 6.5 9.33 6.2 9.33 5.83C9.33 5.46 9.63 5.16 10 5.16C10.36 5.16 10.66 5.46 10.66 5.83Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 5.83C8 6.2 7.7 6.5 7.33 6.5C6.96 6.5 6.66 6.2 6.66 5.83C6.66 5.46 6.96 5.16 7.33 5.16C7.7 5.16 8 5.46 8 5.83Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33 5.83C5.33 6.2 5.03 6.5 4.66 6.5C4.29 6.5 4 6.2 4 5.83C4 5.46 4.29 5.16 4.66 5.16C5.03 5.16 5.33 5.46 5.33 5.83Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66 5.83C2.66 6.2 2.36 6.5 2 6.5C1.63 6.5 1.33 6.2 1.33 5.83C1.33 5.46 1.63 5.16 2 5.16C2.36 5.16 2.66 5.46 2.66 5.83Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.66 8.16C10.66 8.52 10.36 8.82 10 8.82C9.63 8.82 9.33 8.52 9.33 8.16C9.33 7.79 9.63 7.49 10 7.49C10.36 7.49 10.66 7.79 10.66 8.16Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 8.16C8 8.52 7.7 8.82 7.33 8.82C6.96 8.82 6.66 8.52 6.66 8.16C6.66 7.79 6.96 7.49 7.33 7.49C7.7 7.49 8 7.79 8 8.16Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33 8.16C5.33 8.52 5.03 8.82 4.66 8.82C4.29 8.82 4 8.52 4 8.16C4 7.79 4.29 7.49 4.66 7.49C5.03 7.49 5.33 7.79 5.33 8.16Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66 8.16C2.66 8.52 2.36 8.82 2 8.82C1.63 8.82 1.33 8.52 1.33 8.16C1.33 7.79 1.63 7.49 2 7.49C2.36 7.49 2.66 7.79 2.66 8.16Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 10.48C8 10.84 7.7 11.14 7.33 11.14C6.96 11.14 6.66 10.84 6.66 10.48C6.66 10.11 6.96 9.81 7.33 9.81C7.7 9.81 8 10.11 8 10.48Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33 10.48C5.33 10.84 5.03 11.14 4.66 11.14C4.29 11.14 4 10.84 4 10.48C4 10.11 4.29 9.81 4.66 9.81C5.03 9.81 5.33 10.11 5.33 10.48Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66 10.48C2.66 10.84 2.36 11.14 2 11.14C1.63 11.14 1.33 10.84 1.33 10.48C1.33 10.11 1.63 9.81 2 9.81C2.36 9.81 2.66 10.11 2.66 10.48Z",
    fill: "#8C8E90",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.0669c082002c95c038716d874e250dbc.svg";
export { ForwardRef as ReactComponent };